// extracted by mini-css-extract-plugin
export default {"decorated-link":"index-module__decorated-link___QVy4w","decoratedLink":"index-module__decorated-link___QVy4w","active":"index-module__active___c06Rb"};